import React from 'react';



const SansmrutiIntroduction = () => {
    return (
        <div style={{ 
            padding: '40px 20px', 
            maxWidth: '900px', 
            margin: '0 auto', 
            fontFamily: 'Arial, sans-serif',
            color: '#2d3436',
            fontWeight: 'bold' // Makes all text in the container bold
        }}>
            <h2 
                className="top-banner__h2" 
                style={{ 
                    fontFamily: 'Arial', 
                    color: '#032167', 
                    fontSize: '30px', 
                    textAlign: 'center', // This centers the text
                    marginBottom: '20px' 
                }}
            >
                Introduction
            </h2>
            
            <div style={{ 
                textAlign: 'justify', 
                lineHeight: '1.8', 
                fontSize: '1.1rem' 
            }}>
                <p>Every child idolizes his or her parents as their first idol.</p>
                
                <p>Whichever field our parents were, whatever money they earned they always tried to give the best living, the best education, the best facilities for their children to excel.</p>
                
                <p>In the twilight of their life, our parents—senior citizens need small warm gestures, some light cosy moments, someone to chat with, need someone who would listen to them.</p>
                
                <p>"SANSMRUTI PRAKASHAN" helps you in this endeavour to pay GRATITUDE to your parents by writing their life story—biography.</p>
                
                <p>The entire journey of writing a book on your parents' life rejuvenates them, with an experience of reliving all those golden moments of their life.</p>
                
                <p>This book will be treasured forever for all generations to know our roots and struggle for reaching the current position & possessions.</p>
                
                <p style={{ textAlign: 'center', margin: '25px 0', fontSize: '1.2rem', color: '#54a50f' }}>
                    Lets write a book on your parents—for your parents
                </p>
                
                <p>Apart from this we also promote any "SUCCESS STORIES".</p>
                
                <p>Irrespective of your age, gender, or financial status, if you have done something in life which can INSPIRE anyone in the society, you have a book to write. Let your good deeds reach out to the society. This book can definitely bring a positive change you envision.</p>
                
                <p>A book never sees a dustbin. This will be treasured for ages and generations and will leave your legacy too after you perish from this world.</p>
                
                <p>Our team makes this book writing journey easy and funfilled for your family.</p>
                
                <p style={{ textAlign: 'center', fontSize: '1.2rem', marginTop: '20px' }}>
                    We publish books in ENGLISH, MARATHI & HINDI languages.
                </p>
            </div>

            <div style={{ 
                marginTop: '40px', 
                padding: '20px', 
                backgroundColor: '#f8f9fa', 
                borderRadius: '8px', 
                textAlign: 'center',
                border: '1px solid #e1e4e8'
            }}>
                <p style={{ margin: '0' }}>Contact for the different packages</p>
                <p style={{ fontSize: '1.4rem', color: '#54a50f', margin: '5px 0' }}>
                    Whatsapp: 8080420434
                </p>
            </div>
        </div>
    );
}

export default SansmrutiIntroduction;